<template>
  <div class="checkin-page">
    <div class="content">
      <!-- 状态栏装饰 -->
      <div class="status-bar">
        <img src="/qrcode-images/Layer_1.png" alt="status" class="status-img" />
      </div>

      <!-- 标题区域 -->
      <div class="title-section">
        <h1 class="main-title">多多指教！</h1>
        <p class="sub-title">您已完成所有活动任务</p>
      </div>

      <!-- 核销码卡片 -->
      <div class="qrcode-card">
        <div class="fido-image">
          <img src="/qrcode-images/03d3762f-38df-4f95-aaba-465d8f6d703e.png" alt="Fido Dido" />
        </div>
        <div class="card-bg">
          <h3 class="card-title">您的核销码</h3>
          <p class="card-tip">请向工作人员出示您的核销码</p>
          <p class="card-location">核销地点：L4 艺术商店 Art Pavilion</p>
          <p class="card-time">*每天11:00-20:00期间</p>
          <div class="qrcode-wrapper" v-if="checkinQrDataUrl">
            <img :src="checkinQrDataUrl" alt="核销码" class="qrcode-img" />
          </div>
          <div class="qrcode-loading" v-else>
            <div class="spinner"></div>
            <p>正在生成核销码...</p>
          </div>
        </div>
      </div>

      <!-- 品牌好友区域 -->
      <div class="brand-section">
        <p class="brand-title">品牌好友</p>
        <div class="brand-logos">
          <div class="brand-logo-small">
            <img src="/qrcode-images/c479657d426059f5bf669f5b16af2ae741d735e6.png" alt="Fido Dido" />
          </div>
          <div class="brand-logo-large">
            <img src="/qrcode-images/Group0.png" alt="Fido Dido" />
            <img src="/qrcode-images/Group.png" alt="Fido Dido" class="logo-deco" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { getQrcodeByPhone } from '@/api/user'
import QRCode from 'qrcode'

export default {
  name: 'CheckinPage',
  setup() {
    const router = useRouter()
    const checkinQrDataUrl = ref('')
    const userPhone = ref('')

    onMounted(() => {
      // 检查是否已登录
      const storedPhone = localStorage.getItem('userPhone')
      if (!storedPhone) {
        // 未登录，跳转到登录页面
        router.push('/login')
        return
      }
      
      userPhone.value = storedPhone
      
      // 检查用户是否已核销（checkinStatus === 1）
      const checkinStatus = localStorage.getItem('checkinStatus')
      if (checkinStatus === '1') {
        // 已核销，直接加载核销码显示
        loadCheckinQrCode()
        return
      }
      
      // 检查是否已完成关注任务（从后端返回的数字 1 表示已关注）
      const followedAccount1 = localStorage.getItem('followedAccount1') === '1'
      const followedAccount2 = localStorage.getItem('followedAccount2') === '1'
      
      if (!followedAccount1 || !followedAccount2) {
        // 未完成关注任务，跳转到活动页面
        router.push('/activity')
        return
      }
      
      // 加载核销码
      loadCheckinQrCode()
    })

    // 加载核销码
    const loadCheckinQrCode = async () => {
      if (!userPhone.value) return
      
      try {
        const res = await getQrcodeByPhone(userPhone.value)
        if (res.code === 200 && res.data) {
          checkinQrDataUrl.value = await QRCode.toDataURL(res.data, {
            width: 177,
            margin: 2,
            color: {
              dark: '#000000',
              light: '#ffffff'
            }
          })
        }
      } catch (error) {
        console.error('加载核销码失败', error)
      }
    }

    return {
      checkinQrDataUrl
    }
  }
}
</script>

<style scoped>
* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

.checkin-page {
  width: 100%;
  height: 100vh;
  background-color: #ffffff;
  position: relative;
  overflow: hidden;
}

.content {
  width: 100%;
  max-width: 375px;
  height: 100vh;
  margin: 0 auto;
  position: relative;
  padding: 0 15px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

/* 状态栏 */
.status-bar {
  width: 100vw;
  height: 17px;
  overflow: hidden;
  margin-left: calc(-50vw + 50%);
  position: relative;
  flex-shrink: 0;
}

.status-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

/* 标题区域 */
.title-section {
  text-align: center;
  padding-top: 30px;
  margin-bottom: 20px;
  flex-shrink: 0;
}

.main-title {
  font-size: 32px;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', sans-serif;
  font-weight: 700;
  color: #000000;
  line-height: 36px;
  margin-bottom: 10px;
}

.sub-title {
  font-size: 12px;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', sans-serif;
  font-weight: 500;
  color: #000000;
  line-height: 18px;
}

/* 核销码卡片 */
.qrcode-card {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
  position: relative;
}

.fido-image {
  position: relative;
  width: 220px;
  height: 90px;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  z-index: 10;
  margin-bottom: -20px;
}

.fido-image img {
  height: 100%;
  width: auto;
  object-fit: contain;
}

.card-bg {
  width: 308px;
  height: 360px;
  background-color: #2c2a29;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 30px 20px 50px;
  position: relative;
}

.card-title {
  font-size: 14px;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', sans-serif;
  font-weight: 700;
  color: #ffffff;
  line-height: 24px;
  margin-bottom: 5px;
}

.card-tip {
  font-size: 10px;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', sans-serif;
  font-weight: 400;
  color: #ffffff;
  line-height: 24px;
  margin-bottom: 5px;
}

.card-location {
  font-size: 10px;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', sans-serif;
  font-weight: 400;
  color: #ffffff;
  line-height: 24px;
  margin-bottom: 5px;
}

.card-time {
  font-size: 10px;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', sans-serif;
  font-weight: 400;
  color: #ffffff;
  line-height: 24px;
  margin-bottom: 20px;
}

.qrcode-wrapper {
  width: 177px;
  height: 177px;
  background-color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 10px;
}

.qrcode-img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.qrcode-loading {
  width: 177px;
  height: 177px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #ffffff;
  margin-bottom: 10px;
}

.spinner {
  width: 40px;
  height: 40px;
  border: 3px solid rgba(255, 255, 255, 0.3);
  border-top-color: #ffffff;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: 10px;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

/* 品牌好友区域 */
.brand-section {
  width: 179px;
  margin: 0 auto 30px;
  text-align: center;
  flex-shrink: 0;
}

.brand-title {
  font-size: 12px;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', sans-serif;
  font-weight: 400;
  color: #000000;
  line-height: 18px;
  margin-bottom: 10px;
}

.brand-logos {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
}

.brand-logo-small {
  width: 32px;
  height: 26px;
}

.brand-logo-small img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.brand-logo-large {
  width: 121px;
  height: 21px;
  position: relative;
}

.brand-logo-large img {
  width: 93.99%;
  height: 100%;
  object-fit: contain;
}

.logo-deco {
  position: absolute;
  right: 0;
  top: 19.62%;
  width: 6.03% !important;
  height: 20.98% !important;
}

/* 响应式适配 */

/* 小屏幕手机 (iPhone SE, 小屏安卓) */
@media screen and (max-width: 375px) {
  .content {
    padding: 0 10px;
  }
  
  .title-section {
    padding-top: 20px;
    margin-bottom: 15px;
  }
  
  .main-title {
    font-size: 28px;
    line-height: 32px;
    margin-bottom: 8px;
  }
  
  .sub-title {
    font-size: 11px;
  }
  
  .qrcode-card {
    margin-bottom: 15px;
  }
  
  .fido-image {
    width: 190px;
    height: 75px;
    margin-bottom: -15px;
  }
  
  .card-bg {
    width: 280px;
    height: 340px;
    padding: 25px 15px 50px;
  }
  
  .card-title {
    font-size: 13px;
  }
  
  .card-tip {
    font-size: 9px;
    margin-bottom: 5px;
  }
  
  .card-location {
    font-size: 9px;
    margin-bottom: 5px;
  }
  
  .card-time {
    font-size: 9px;
    margin-bottom: 15px;
  }
  
  .qrcode-wrapper,
  .qrcode-loading {
    width: 160px;
    height: 160px;
  }
  
  .brand-section {
    margin-bottom: 20px;
  }
}

/* 中等屏幕手机 (iPhone 12/13/14, 安卓标准屏) */
@media screen and (min-width: 376px) and (max-width: 414px) {
  .content {
    padding: 0 12px;
  }
  
  .title-section {
    padding-top: 25px;
    margin-bottom: 15px;
  }
  
  .main-title {
    font-size: 30px;
    line-height: 34px;
  }
  
  .sub-title {
    font-size: 11px;
  }
  
  .qrcode-card {
    margin-bottom: 15px;
  }
  
  .fido-image {
    width: 200px;
    height: 80px;
    margin-bottom: -18px;
  }
  
  .card-bg {
    width: 290px;
    height: 350px;
    padding: 28px 18px 53px;
  }
  
  .card-title {
    font-size: 13px;
  }
  
  .card-tip {
    font-size: 10px;
    margin-bottom: 5px;
  }
  
  .card-location {
    font-size: 10px;
    margin-bottom: 5px;
  }
  
  .card-time {
    font-size: 10px;
    margin-bottom: 18px;
  }
  
  .qrcode-wrapper,
  .qrcode-loading {
    width: 170px;
    height: 170px;
  }
  
  .brand-section {
    margin-bottom: 25px;
  }
}

/* 大屏幕手机 (iPhone 14 Pro Max, 大屏安卓) */
@media screen and (min-width: 415px) and (max-width: 430px) {
  .content {
    padding: 0 15px;
  }

  .title-section {
    padding-top: 35px;
    margin-bottom: 20px;
  }

  .main-title {
    font-size: 34px;
    line-height: 38px;
    margin-bottom: 12px;
  }

  .sub-title {
    font-size: 12px;
  }

  .qrcode-card {
    margin-bottom: 20px;
  }

  .fido-image {
    width: 210px;
    height: 85px;
    margin-bottom: -20px;
  }

  .card-bg {
    width: 300px;
    height: 360px;
    padding: 30px 20px 55px;
  }

  .card-title {
    font-size: 14px;
  }

  .card-tip {
    font-size: 10px;
    margin-bottom: 5px;
  }

  .card-location {
    font-size: 10px;
    margin-bottom: 5px;
  }

  .card-time {
    font-size: 10px;
    margin-bottom: 20px;
  }

  .qrcode-wrapper,
  .qrcode-loading {
    width: 180px;
    height: 180px;
  }

  .brand-section {
    margin-bottom: 30px;
  }
}

/* 超大屏幕手机和平板 */
@media screen and (min-width: 431px) {
  .content {
    max-width: 430px;
    padding: 0 18px;
  }

  .title-section {
    padding-top: 40px;
    margin-bottom: 25px;
  }

  .main-title {
    font-size: 36px;
    line-height: 40px;
    margin-bottom: 15px;
  }

  .sub-title {
    font-size: 14px;
  }

  .qrcode-card {
    margin-bottom: 25px;
  }

  .fido-image {
    width: 230px;
    height: 95px;
    margin-bottom: -22px;
  }

  .card-bg {
    width: 320px;
    height: 370px;
    padding: 35px 25px 55px;
  }

  .card-title {
    font-size: 15px;
    margin-bottom: 8px;
  }

  .card-tip {
    font-size: 11px;
    margin-bottom: 5px;
  }

  .card-location {
    font-size: 11px;
    margin-bottom: 5px;
  }

  .card-time {
    font-size: 11px;
    margin-bottom: 22px;
  }

  .qrcode-wrapper,
  .qrcode-loading {
    width: 190px;
    height: 190px;
  }

  .brand-section {
    margin-bottom: 40px;
  }

  .brand-title {
    font-size: 14px;
    margin-bottom: 12px;
  }
}

/* 横屏适配 */
@media screen and (max-height: 600px) and (orientation: landscape) {
  .content {
    padding: 0 10px;
  }
  
  .title-section {
    padding-top: 10px;
    margin-bottom: 10px;
  }
  
  .main-title {
    font-size: 24px;
    line-height: 28px;
    margin-bottom: 5px;
  }
  
  .sub-title {
    font-size: 10px;
  }
  
  .qrcode-card {
    margin-bottom: 10px;
  }

  .fido-image {
    width: 170px;
    height: 65px;
    margin-bottom: -12px;
  }

  .card-bg {
    width: 260px;
    height: 320px;
    padding: 22px 15px 48px;
  }
  
  .card-title {
    font-size: 12px;
    margin-bottom: 3px;
  }
  
  .card-tip {
    font-size: 9px;
    margin-bottom: 5px;
  }
  
  .card-location {
    font-size: 9px;
    margin-bottom: 5px;
  }
  
  .card-time {
    font-size: 9px;
    margin-bottom: 10px;
  }
  
  .qrcode-wrapper,
  .qrcode-loading {
    width: 150px;
    height: 150px;
  }
  
  .brand-section {
    margin-bottom: 15px;
  }
}
</style>
